export const LOGIN_METHOD = {
  otp: 'otp',
  google: 'google',
  both: 'both',
} as const

export type LoginMethod = (typeof LOGIN_METHOD)[keyof typeof LOGIN_METHOD]

export const PAYMENT_METHOD = {
  cod: 'cod',
  online: 'online',
  both: 'both',
} as const

export type PaymentMethod = (typeof PAYMENT_METHOD)[keyof typeof PAYMENT_METHOD]

export type StorefrontSettings = {
  loginMethod: LoginMethod
  paymentMethod: PaymentMethod
  googleClientId: string | null
  updatedAt: string
}

export const FALLBACK_STOREFRONT_SETTINGS: StorefrontSettings = {
  loginMethod: LOGIN_METHOD.google,
  paymentMethod: PAYMENT_METHOD.cod,
  googleClientId: null,
  updatedAt: '',
}

export const SETTINGS_API_PATHS = {
  root: '/settings',
} as const
